import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const LiveActivityDashboard = ({ recentActivity, onRefresh }) => {
  const getStatusBadge = (log) => {
    if (!log?.check_out_time) {
      return (
        <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium bg-success/10 text-success">
          <Icon name="CheckCircle" size={12} />
          Checked In
        </span>
      );
    }
    return (
      <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium bg-muted text-muted-foreground">
        <Icon name="LogOut" size={12} />
        Checked Out
      </span>
    );
  };

  const formatTime = (timestamp) => {
    if (!timestamp) return 'N/A';
    return new Date(timestamp)?.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="bg-card rounded-xl shadow-md border border-border">
      <div className="p-6 border-b border-border flex items-center justify-between">
        <h2 className="text-xl font-heading font-bold text-foreground flex items-center gap-2">
          <Icon name="Activity" size={24} color="var(--color-primary)" />
          Live Member Activity
        </h2>
        <Button onClick={onRefresh} variant="ghost" size="sm">
          <Icon name="RefreshCw" size={18} />
        </Button>
      </div>

      <div className="p-6">
        {recentActivity?.length === 0 ? (
          <div className="text-center py-12">
            <Icon name="Users" size={48} className="mx-auto mb-4 text-muted-foreground" />
            <p className="text-muted-foreground">No recent activity</p>
          </div>
        ) : (
          <div className="space-y-3 max-h-[500px] overflow-y-auto">
            {recentActivity?.map((log) => (
              <div
                key={log?.id}
                className="p-4 bg-background rounded-lg border border-border hover:border-primary/50 transition-smooth"
              >
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center overflow-hidden">
                      {log?.user_profiles?.avatar_url ? (
                        <img
                          src={log?.user_profiles?.avatar_url}
                          alt={log?.user_profiles?.full_name}
                          className="w-full h-full object-cover"
                        />
                      ) : (
                        <Icon name="User" size={20} className="text-primary" />
                      )}
                    </div>
                    <div>
                      <p className="font-semibold text-foreground">
                        {log?.user_profiles?.full_name}
                      </p>
                      <p className="text-xs text-muted-foreground">
                        {log?.user_profiles?.email}
                      </p>
                    </div>
                  </div>
                  {getStatusBadge(log)}
                </div>

                <div className="grid grid-cols-3 gap-4 text-sm">
                  <div>
                    <p className="text-xs text-muted-foreground mb-1">Check-In</p>
                    <p className="font-medium text-foreground">
                      {formatTime(log?.check_in_time)}
                    </p>
                  </div>
                  <div>
                    <p className="text-xs text-muted-foreground mb-1">Check-Out</p>
                    <p className="font-medium text-foreground">
                      {log?.check_out_time ? formatTime(log?.check_out_time) : 'Active'}
                    </p>
                  </div>
                  <div>
                    <p className="text-xs text-muted-foreground mb-1">Entry Type</p>
                    <p className="font-medium text-foreground capitalize">
                      {log?.entry_type?.replace('_', ' ')}
                    </p>
                  </div>
                </div>

                {log?.member_barcodes && (
                  <div className="mt-3 pt-3 border-t border-border">
                    <p className="text-xs text-muted-foreground mb-1">Barcode</p>
                    <p className="text-xs font-mono text-foreground">
                      {log?.member_barcodes?.barcode_data}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LiveActivityDashboard;